import { render, staticRenderFns } from "./Multiposting.vue?vue&type=template&id=0ae759c8"
import script from "./Multiposting.vue?vue&type=script&lang=ts"
export * from "./Multiposting.vue?vue&type=script&lang=ts"
import style0 from "./Multiposting.vue?vue&type=style&index=0&id=0ae759c8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports